module.exports = __webpack_public_path__ + "img/RedefiningEducationalExcellence.ee54cede.jpg";